import { createRequestHelper } from '@utils/swr'
import { type GetUserPaymentTokenRequest } from '../types/apiRequest'
import { type WpUserPaymentTokenListResponse } from '../types/apiResponse'
import { type ECommerceV2Apis } from '../types/apis'

const { useRequest } = createRequestHelper<
  ECommerceV2Apis['get']['userPaymentToken'],
  WpUserPaymentTokenListResponse,
  GetUserPaymentTokenRequest
>({
  client: 'eCommerceV2',
  key: (params) => {
    if (!params) return null
    const { country_code } = params
    if (!country_code) return null
    return `/${country_code}/user/payment_tokens`
  },
  isImmutable: true,
})

export const useApiECommerceUserPaymentTokens = useRequest
